import {ReactNode} from "react";

export type KpiCell = {
  title: string;
  // undefined while loading, 0 when there is nothing to show
  value: number | undefined;
  icon?: ReactNode;
  onClick?: () => void;
}

// keeps a grid slot free
export const EMPTY_KPI_CELL: KpiCell = {title: '', value: 0}

const hasValue = (cell: KpiCell) => !!cell.value && cell.value > 0

/**
 * Cells with a value come first, then the loading ones, then the empty ones.
 * A fourth cell is only kept when it has a value, so an empty one never opens a second row.
 */
export const sortKpiCells = (cells: KpiCell[]): KpiCell[] => {
  const sorted = [
    ...cells.filter(hasValue),
    ...cells.filter((cell) => cell.value === undefined),
    ...cells.filter((cell) => cell.value === 0),
  ]
  if (sorted.length > 3 && !hasValue(sorted[sorted.length - 1])) {
    sorted.pop()
  }
  return sorted
}

// whether the cells take up space in the widget: something to show or still loading
export const hasKpiData = (cells: KpiCell[]): boolean => (
  cells.some((cell) => cell.value === undefined || hasValue(cell))
)
